exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cookie-consent .message {\n  text-align: center;\n  font-size: 1.5em; }\n\n.cookie-consent a:hover {\n  color: white; }\n\n.cookie-consent a:focus {\n  color: #53B7E8; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./src/style/components/notification/cookie-banner.scss
// module id = 1270
// module chunks = 49